import React from 'react'

export default function Discount() {
  return (
    <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_2924_18797)'>
        <path
          opacity='0.3'
          d='M4.0013 7.33341C5.84225 7.33341 7.33463 5.84103 7.33463 4.00008C7.33463 2.15913 5.84225 0.666748 4.0013 0.666748C2.16035 0.666748 0.667969 2.15913 0.667969 4.00008C0.667969 5.84103 2.16035 7.33341 4.0013 7.33341Z'
          fill='#405189'
        />
        <path
          d='M4.0013 3.53345C4.08971 3.53345 4.17449 3.56857 4.237 3.63108C4.29952 3.69359 4.33464 3.77838 4.33464 3.86678V5.42011C4.33464 5.50852 4.29952 5.5933 4.237 5.65582C4.17449 5.71833 4.08971 5.75345 4.0013 5.75345C3.9129 5.75345 3.82811 5.71833 3.7656 5.65582C3.70309 5.5933 3.66797 5.50852 3.66797 5.42011V3.86678C3.66797 3.77838 3.70309 3.69359 3.7656 3.63108C3.82811 3.56857 3.9129 3.53345 4.0013 3.53345Z'
          fill='#405189'
        />
        <path
          d='M4.0026 3.08016C4.23272 3.08016 4.41927 2.89361 4.41927 2.66349C4.41927 2.43337 4.23272 2.24683 4.0026 2.24683C3.77249 2.24683 3.58594 2.43337 3.58594 2.66349C3.58594 2.89361 3.77249 3.08016 4.0026 3.08016Z'
          fill='#405189'
        />
      </g>
      <defs>
        <clipPath id='clip0_2924_18797'>
          <rect width='15' height='15' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
